const initialSubscriptionModel = {
    isSubscriptionDialogOpen: false as boolean,
    isManageSubscriptionDialogOpen: false as boolean,
    isChangeSubscriptionDialogOpen: false as boolean,

}

export const initialState = {
    subscriptionModel: initialSubscriptionModel,
}

export type SubscriptionStateType = typeof initialState;